import { render, staticRenderFns } from "./inspectionTaskForm.vue?vue&type=template&id=2647bf4e&scoped=true&"
import script from "./inspectionTaskForm.vue?vue&type=script&lang=js&"
export * from "./inspectionTaskForm.vue?vue&type=script&lang=js&"
import style0 from "./inspectionTaskForm.vue?vue&type=style&index=0&id=2647bf4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2647bf4e",
  null
  
)

export default component.exports